export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14250.18219d61.jpg";